<template>
  <widget
    :color="color"
    icon="fa fa-robot"
    title="Answered calls"
    :percent="percent"
    :value="value"
    :tooltip="tooltip"
  />
</template>

<script>
import apiRealtime from '@/apis/realtime'

import Widget from '@/components/widget/widget10'

export default {
  props: {
    refresh: Boolean
  },
  components: {
    Widget
  },
  data() {
    return {
      color:
        this.direction === 'outbound'
          ? this.$getVoiceOutboundColor[0]
          : this.$getVoiceColor[0],
      percent: 0,
      value: 0,
      tooltip: '%Answer = 0'
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler(val) {
        this.getVoiceAnsweredCall()
      }
    }
  },
  methods: {
    async getVoiceAnsweredCall() {
      try {
        const answeredCall = await apiRealtime.getVoiceAnsweredCall()

        this.value = answeredCall.total
        this.percent = answeredCall.percent

        if (answeredCall.all !== 0)
          this.tooltip = `%Answer = ${answeredCall.total} / ${answeredCall.all}`

        this.$emit('reset', 'voiceAnsweredCall')
      } catch (error) {}
    }
  }
}
</script>
